import React, { useState, useEffect, useRef } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { faqAccordionStyles } from './FAQAccordion.styles';
import { faqItems } from '../../../../../constants/faqQuestions';

const FAQAccordion = () => {
  const [expanded, setExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box ref={containerRef} sx={faqAccordionStyles.accordionContainer}>
      {faqItems.map((faq, index) => {
        const panelId = faq.question;
        const isExpanded = expanded === panelId;
        const delay = index === 0 ? 0 : index === 1 ? 0.5 : index * 0.2;

        return (
          <Accordion
            key={panelId}
            expanded={isExpanded}
            onChange={handleChange(panelId)}
            sx={{
              ...faqAccordionStyles.accordion,
              ...faqAccordionStyles.fadeIn(isVisible, delay),
            }}
            elevation={0}
            disableGutters
          >
            <AccordionSummary
              expandIcon={
                isExpanded ? (
                  <Remove sx={faqAccordionStyles.expandIcon} />
                ) : (
                  <Add sx={faqAccordionStyles.expandIcon} />
                )
              }
              sx={faqAccordionStyles.accordionSummary}
            >
              <Typography sx={faqAccordionStyles.accordionTitle}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={faqAccordionStyles.accordionDetails}>
              <Typography sx={faqAccordionStyles.accordionContent}>
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default FAQAccordion;

